import axios from 'axios';
import {
  devApiUrl,
  prodApiUrl,
  stageApiUrl,
  localUrl,
  stageUrl,
  prodUrl,
} from '../../config/config';

// if (window.location.hostname === localUrl) {
//   axios.defaults.baseURL = devApiUrl;
//   console.log('dev');
// }
//
// if (window.location.hostname === stageUrl) {
//   axios.defaults.baseURL = stageApiUrl;
//   console.log('stage');
// }
//
// if (window.location.hostname === prodUrl) {
//   axios.defaults.baseURL = prodApiUrl;
//   console.log('prod');
// }

axios.defaults.baseURL = prodApiUrl;

axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default axios;



// WEBPACK FOOTER //
// ./src/system/utils/Http.js